export default "__VITE_ASSET__DVw721Ma__"